import styled from 'styled-components';

export const Ripple = styled.div<{ color?: string }>`
  display: inline-block;
  position: relative;
  width: 24px;
  height: 24px;

  div {
    position: absolute;
    border: ${({ color }) => `4px solid ${color}`};
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }

  div:nth-child(2) {
    animation-delay: -0.5s;
  }

  @keyframes lds-ripple {
    0% {
      top: 16px;
      left: 16px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 32px;
      height: 32px;
      opacity: 0;
    }
  }
`;
